// 在庫数量以上のお問い合わせフォーム（fukuro.in page/2510・2523・2524。ES さんの Worker 送信のフォーム）で、
// 直前に見ていた商品名を「商品名・品番」欄（#zk_item）に先入れする。
//
// もとは ocnk 管理画面「SEO(メタタグ)全体設定 → ヘッダー」直書きの <!-- fkro-item-prefill --> の後半。
// 商品ページ側で Cookie zk_last_item を書くのは hooks/stock-check.ts。
// 将来リンク先を wuStorefront の在庫不足ウィジェット（?p=管理番号）にすれば、この Cookie 経路ごと不要になる。

import { LAST_ITEM_COOKIE } from './stock-check'

export function readCookie(name: string, cookie: string = document.cookie): string {
  const m = cookie.match('(?:^|; )' + name + '=([^;]*)')
  return m ? decodeURIComponent(m[1]) : ''
}

export default function stockInquiryPrefill(): void {
  const f = document.querySelector<HTMLInputElement>('#zk_item,[name="item"]')
  if (!f || f.value) return
  const v = readCookie(LAST_ITEM_COOKIE)
  if (!v) return
  f.value = v
  const d = document.createElement('div')
  d.style.cssText = 'font-size:12px;color:#2e7d32;margin-top:4px'
  d.textContent = '先ほどご覧になっていた商品を入れました（違う場合は書き換えてください）'
  f.parentNode?.appendChild(d)
}
